import { Stack } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../components/PageHeader";
import { PlanReport } from "../../components/reports/PlanReport";
import { foyerApi } from "../../http/foyer";

/** The provider's own organisation-plan report (ORG-8). */
export default function SupplierReportsPage() {
  const { t } = useTranslation("supplier");
  const load = useCallback(
    (p: { from: string; to: string }) => foyerApi.ownerPlanReport(p),
    []
  );
  return (
    <Stack spacing={3}>
      <PageHeader
        eyebrow={t("supplierReportsPage.eyebrow")}
        title={t("supplierReportsPage.title")}
        subtitle={t("supplierReportsPage.subtitle")}
      />
      <PlanReport load={load} />
    </Stack>
  );
}
